export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT; //production | development

console.log("ENVIRONMENT", ENVIRONMENT);

export const COMPANY_NAME = process.env.REACT_APP_APP_NAME;
export const PROJECT_META_NAME = process.env.VITE_APP_COOKIE_NAME;
export const PRODUCT_SLUG = process.env.REACT_APP_PRODUCT_SLUG || "notes";
export const IDOM_API_URL =
  process.env.REACT_APP_IDOM_API_URL ||
  (ENVIRONMENT === "production"
    ? "https://api.idom.in/"
    : ENVIRONMENT === "uat"
    ? "https://uat-api.idom.in/"
    : "https://sapi.idom.in/");

const getKey = (suffix) => {
  const envPrefix =
    ENVIRONMENT === "production"
      ? "prod"
      : ENVIRONMENT === "uat"
      ? "uat"
      : "dev";
  return `${process.env.REACT_APP_APP_COOKIE_NAME}_${envPrefix}_${suffix}`;
};

export const config = {
  apiurl:
    ENVIRONMENT === "production"
      ? process.env.REACT_APP_PRODUCTION_API_URL
      : ENVIRONMENT === "uat"
      ? process.env.REACT_APP_UAT_API_URL
      : process.env.REACT_APP_DEVELOPMENT_API_URL,
};

export const TOKEN_NAME = getKey("token");
export const COMPANYNAME = getKey("company_name");
export const NAME = getKey("name");
export const COMPANY_ID = getKey("company_id");
export const COMPANY_EMPLOYEE_ID = getKey("company_employee_id");
export const ROLE = getKey("role");
export const USERNAME = getKey("username");

// Redirect URLs and Service Keys
export const redirectUrl =
  ENVIRONMENT === "production"
    ? process.env.REACT_APP_REDIRECT_PROD_DOMAIN
    : ENVIRONMENT === "uat"
    ? process.env.REACT_APP_REDIRECT_UAT_DOMAIN
    : process.env.REACT_APP_REDIRECT_DEV_DOMAIN;

export const serviceKey =
  ENVIRONMENT === "production"
    ? process.env.REACT_APP_NOTES_PROD_APP_ID
    : ENVIRONMENT === "uat"
    ? process.env.REACT_APP_NOTES_UAT_APP_ID
    : process.env.REACT_APP_NOTES_DEV_APP_ID;
